"use strict";

var _slicedToArray = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Generator = void 0;

var validator_1 = require("./validator");

var versions_1 = require("./versions");

var Generator = /*#__PURE__*/function () {
  function Generator(version) {
    _classCallCheck(this, Generator);

    versions_1.validateVersion(version);

    var _version$split = version.split('-'),
        _version$split2 = _slicedToArray(_version$split, 2),
        name = _version$split2[0],
        calVer = _version$split2[1];

    this.name = name;
    this.calVer = calVer;
  }
  /**
   * Generates valid, minfied, and ordered (alphabetized keys) schema
   * Raises if the unordered json does not Validate against the Generator's schema
   *
   * @param unordered
   */


  _createClass(Generator, [{
    key: "generateJSON",
    value: function generateJSON(unordered) {
      // validate the schema
      var version = this.name.concat('-').concat(this.calVer);
      var validator = new validator_1.Validator(version);
      var validated = validator.validate(unordered);

      if (!validated) {
        throw new Error("JSON does not conform to the ".concat(version, " schema."));
      } // alphabetize key


      var ordered = {};
      Object.keys(unordered).sort().forEach(function (key) {
        ordered[key] = unordered[key];
      });
      return JSON.stringify(ordered); // minify
    }
  }]);

  return Generator;
}();

exports.Generator = Generator;